module.exports = __webpack_public_path__ + "static/media/435_Bathroom2.6e9d2302.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/GalleryPhotos/435_Bathroom2.jpg
// module id = 552
// module chunks = 0